import { capitalize } from 'lodash';
import moment from 'moment-timezone';
import type React from 'react';
import {
	getCallDuration,
	getCallIcon,
} from 'src/components/job-slide-out/components/nav-table/tenant-lula-chat/utils';
import type { TenantContactMessage } from 'src/types';

interface CallLogMessageProps {
	message: TenantContactMessage;
	jobTimezone: string;
}

const CallLogMessage: React.FC<CallLogMessageProps> = ({
	message,
	jobTimezone,
}) => {
	let calledAt = '';
	if (message.call_date_started && jobTimezone) {
		const m = moment
			.utc(message.call_date_started, 'YYYY-MM-DD HH:mm:ss')
			.tz(jobTimezone);
		const now = moment.tz(jobTimezone);
		if (m.isSame(now, 'day')) {
			calledAt = `at ${m.format('hh:mmA z')}`;
		} else if (m.isSame(now.clone().subtract(1, 'day'), 'day')) {
			calledAt = `Yesterday at ${m.format('hh:mmA z')}`;
		} else {
			calledAt = m.format('MMM D, YYYY - hh:mm A z');
		}
	}
	const dateLine = `${calledAt} ${
		message.call_duration ? `for ${getCallDuration(message.call_duration)}` : ''
	}`.trim();

	return (
		<div
			className={`tenant-texts__row tenant-texts__row--${message.direction} tenant-texts__row--call`}
		>
			<div className="tenant-texts__call">
				<div className="tenant-texts__call-icon" aria-hidden="true">
					{getCallIcon(message.call_type, message.direction)}
				</div>
				<div className="tenant-texts__call-data">
					{message.sender ? (
						<div className="tenant-texts__call-user">
							{message.call_type ? `${capitalize(message.call_type)} ` : ''}
							Call by {message.sender}
							{message.designation ? (
								<span> ({message.designation})</span>
							) : null}
						</div>
					) : null}
					{dateLine ? (
						<div className="tenant-texts__call-date">{dateLine}</div>
					) : null}
				</div>
			</div>
		</div>
	);
};

export default CallLogMessage;
